export function lightenHexColor(hexColor: string, lightenFactor: number) {
    // Remove '#' if present
    if (!hexColor) return null;
    const color = hexColor.replace('#', '');

    // Convert hex to RGB
    const red = parseInt(color.substring(0, 2), 16);
    const green = parseInt(color.substring(2, 4), 16);
    const blue = parseInt(color.substring(4, 6), 16);

    // Lighten the color (You can adjust the lighten factor as needed)
    const newRed = Math.floor((1 - lightenFactor) * red + lightenFactor * 255);
    const newGreen = Math.floor((1 - lightenFactor) * green + lightenFactor * 255);
    const newBlue = Math.floor((1 - lightenFactor) * blue + lightenFactor * 255);

    // Ensure the values are within 0-255 range
    const adjustedRed = Math.max(0, Math.min(255, newRed));
    const adjustedGreen = Math.max(0, Math.min(255, newGreen));
    const adjustedBlue = Math.max(0, Math.min(255, newBlue));

    // Convert adjusted RGB back to hex
    return `#${adjustedRed.toString(16).padStart(2, '0')}${adjustedGreen.toString(16).padStart(2, '0')}${adjustedBlue
        .toString(16)
        .padStart(2, '0')}`;
}
